import {
  colorCss,
  FontProps,
  fontCss,
  lineHeightCss,
  mobileFontCss,
  mobileLineHeightCss,
} from 'common/utils/styleUtilsNew'
import React from 'react'
import styled, { css } from 'styled-components'

export interface OrderTotalWrapperUiProps extends FontProps {
  lineHeight?: number
  mobileLineHeight?: number
}

export const OrderTotalWrapper = styled.div<OrderTotalWrapperUiProps>`
  ${colorCss}
  ${fontCss}
  ${lineHeightCss}

  &:not(:first-child) {
    margin-top: 12px;
  }

  ${p => p.theme.phone} {
    ${mobileFontCss}
    ${mobileLineHeightCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
      ${mobileLineHeightCss}
    `}
`
